var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.316 47.9867H6.66933C2.98533 47.9867 0 45 0 41.316V6.67067C0 2.98667 2.98533 -2.22603e-06 6.66933 -2.22603e-06H41.316C45 -2.22603e-06 47.9867 2.98667 47.9867 6.67067V41.316C47.9867 45 45 47.9867 41.316 47.9867Z",
    fill: "#5602C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9075 15.3124C19.1395 15.3124 15.2621 19.1897 15.2621 23.9577C15.2621 28.7257 19.1395 32.6031 23.9075 32.6031C28.6755 32.6031 32.5528 28.7257 32.5528 23.9577C32.5448 19.1897 28.6688 15.3124 23.9075 15.3124ZM23.9075 39.6644C15.2675 39.6644 8.23682 32.6324 8.23682 23.9937C8.23682 15.3537 15.2675 8.32307 23.9075 8.32307C32.5475 8.32307 39.5781 15.3537 39.5781 23.9937C39.5781 32.6324 32.5475 39.6644 23.9075 39.6644Z",
    fill: "#FF8600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1637 47.9867H62.517C58.833 47.9867 55.8477 45 55.8477 41.316V6.67067C55.8477 2.98667 58.833 -2.22603e-06 62.517 -2.22603e-06H97.1637C100.848 -2.22603e-06 103.834 2.98667 103.834 6.67067V41.316C103.834 45 100.848 47.9867 97.1637 47.9867Z",
    fill: "#5602C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8006 27.5104H95.858V20.4051C88.3766 20.4171 80.8953 20.4251 73.414 20.4277C70.218 20.4291 67.0206 20.4264 63.8233 20.4251V27.5104H75.8166",
    fill: "#FF8600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1637 103.7H62.517C58.833 103.7 55.8477 100.713 55.8477 97.0291V62.3837C55.8477 58.6997 58.833 55.7131 62.517 55.7131H97.1637C100.848 55.7131 103.834 58.6997 103.834 62.3837V97.0291C103.834 100.713 100.848 103.7 97.1637 103.7Z",
    fill: "#FF8600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.316 103.7H6.66933C2.98533 103.7 0 100.713 0 97.0291V62.3837C0 58.6997 2.98533 55.7131 6.66933 55.7131H41.316C45 55.7131 47.9867 58.6997 47.9867 62.3837V97.0291C47.9867 100.713 45 103.7 41.316 103.7Z",
    fill: "#5602C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8737 83.4172V95.4745H19.8897V83.4172H7.89636L9.89636 75.4332H19.8897V63.4398H27.8737V75.4332H39.931V83.4172H27.8737Z",
    fill: "#FF8600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f5edcc706707ca6a279d68b6524a1d2.svg";
export { ForwardRef as ReactComponent };